import { gql } from "@/gql/__generated__";
import { useQuery } from "@apollo/client";
import { useUserActiveOrganization } from "../user/useUserActiveOrganization";

const APP_SHARED_URL = gql(`
  query appSharedURL($appSlug: String!, $organizationSlug: String!) {
    app(appSlug: $appSlug, organizationSlug: $organizationSlug) {
      __typename
      id
      defaultDeployment {
        __typename
        id
        sharedURL
      }
    }
  }
`);

export function useAppSharedURL(appSlug?: string) {
  const { activeOrganization } = useUserActiveOrganization();

  const { data, ...query } = useQuery(APP_SHARED_URL, {
    variables: {
      organizationSlug: activeOrganization?.slug || "",
      appSlug: appSlug || ""
    },
    skip: !activeOrganization || !appSlug
  });

  const appShareURL = data?.app?.defaultDeployment?.sharedURL;

  return { ...query, data: appShareURL };
}
